import React from 'react';
import { getPercentFromCountList } from '../../helpers/vote';
import { Percentage } from '../Percentage/Percentage';
import { PercentageBar } from '../PercentageBar/PercentageBar';
import styles from './VoteFullSize.module.css';

const VoteFullSize = ({
  variants,
  title,
  withResults,
  currentState,
  questionFontSize,
  answerFontSize,
  varNumFontSize,
}) => {
  let percentList = getPercentFromCountList(
    (variants || []).map((el) => +el.count),
  );

  const isLong = title?.length > 160;
  const coefTextVar = variants?.length > 6 ? 0.8 : 1;

  const words = title?.split(' ');
  let globalLetterIndex = 0;

  const durationLetter = 0.03;
  const delayVars = durationLetter * title?.length || 5;

  return (
    <div>
      <div className={styles.wrapper}>
        <div
          className={styles.question}
          style={{
            fontSize: isLong
              ? `${0.8 * questionFontSize}rem`
              : `${questionFontSize}rem`,
          }}
        >
          {words &&
            words.map((word, wordIdx) => {
              return (
                <span key={wordIdx} className={styles.word}>
                  {word.split('').map((l, idx) => {
                    const delay = globalLetterIndex * durationLetter;
                    globalLetterIndex++;
                    return (
                      <span
                        key={l + idx}
                        className={styles.letter}
                        style={{
                          '--delayLetter': `${delay}s`,
                          '--durationLetter': `${durationLetter}s`,
                        }}
                      >
                        {l}
                      </span>
                    );
                  })}
                </span>
              );
            })}
        </div>
        <div
          className={styles.vars}
          style={{ '--delayVars': `${delayVars - 1.5}s` }}
        >
          {variants?.map((item, i) => (
            <div
              key={i}
              className={styles.var}
              style={{ '--delayItemVar': `${delayVars + 0.5 + i * 0.25}s` }}
            >
              <div className={styles.varTextBlock}>
                <div
                  className={styles.varNumber}
                  style={{
                    fontSize: `${varNumFontSize}rem`,
                    minWidth: `${1.2 * varNumFontSize}rem`,
                  }}
                >
                  {i + 1}
                </div>
                <div
                  className={styles.varTitle}
                  style={{
                    fontSize: `${coefTextVar * answerFontSize}rem`,
                  }}
                >
                  {item.comment}
                </div>
              </div>

              <div
                className={styles.varResultBlock}
                style={{ marginLeft: `${1.2 * varNumFontSize}rem` }}
              >
                <div className={styles.varResult}>
                  <PercentageBar
                    width={percentList[i]}
                    resut={currentState === 'S2'}
                  />

                  <div style={{ minWidth: '14.4rem' }}>
                    {currentState === 'S2' && withResults && (
                      <Percentage id={i.toString()} value={percentList[i]} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default React.memo(VoteFullSize);
